module.exports = __webpack_public_path__ + "img/logo-2-dark.c923535b.png";